
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageService } from '../../../../shared/services/language.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-language-switcher',
  standalone: false,
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  currentLanguage = 'pl';
  availableLanguages = [
    { code: 'en', name: 'Angielski', flag: '🇬🇧' },
    { code: 'fr', name: 'Francuski', flag: '🇫🇷' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' }
  ];

  private destroy$ = new Subject<void>();

  constructor(
    private languageService: LanguageService
  ) {
    this.currentLanguage = this.languageService.currentLanguage;
  }

  ngOnInit(): void {
    this.languageService.languageChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang) => {
        if (lang && ['en', 'fr', 'pl'].includes(lang)) {
          this.currentLanguage = lang;
        }
      });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  switchLanguage(languageCode: string): void {
    if (this.currentLanguage === languageCode) {
      return;
    }

    this.languageService.switchLanguage(languageCode);
    this.currentLanguage = languageCode;
  }

  isCurrentLanguage(languageCode: string): boolean {
    return this.currentLanguage === languageCode;
  }
}
